import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import axios from 'axios';
import api from '../../config';

import { Link } from 'react-router-dom';

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUpcomingEvents();
  }, []);

  const fetchUpcomingEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/get/upcoming-events?limit=3`);
      
      if (response.data.isOk) {
        const fetchedEvents = response.data.data || [];
        setEvents(fetchedEvents);
      } else {
        setError('Failed to fetch events');
      }
    } catch (err) {
      console.error('Error fetching upcoming events:', err);
      setError('Failed to load upcoming events');
      
      // Set empty array on error
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="events-section">
        <Container>
          <h2 className="text-center text-dark fw-bold m-5">Upcoming Events</h2>
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  return (
    <section className="events-section">
      <Container>
        <h2 className="text-center text-dark fw-bold m-3 m-lg-5">Upcoming Events</h2>
        {events.length === 0 ? (
          // Show red text when no events
          <div className="text-center my-5">
            <h1 style={{ color: 'red' }}>Event Coming Soon...</h1>
          </div>
        ) : (
          // Show events when available
          <Row className="justify-content-center">
            {events.map((event) => (
              <Col lg={4} md={12} className="mb-5 event-card-custom" key={event._id}>
                <div className="event-card h-100">
                  <img 
                    src={`${api.API_URL}/${event.bannerImage}`} 
                    className="event-img" 
                    alt={event.title}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/placeholder-event.png'; // Fallback image
                    }}
                  />
                  <div className="event-content p-md-4 py-4 px-0">
                    <p className="event-date mb-1">
                      {new Date(event.eventDate).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                    <h4 className="event-title mb-2">{event.title}</h4>
                    <p className="event-desc mb-3">
                      {event.shortDescription}
                    </p>
                    <Link to={`/event/${event.slug}`} className="event-link">
                      See details{' '}
                      <span className="arrow">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </section>
  );
};

export default UpcomingEvents;
